import { ButtonBasic, TextareaDynamicPlaceholder, ButtonClose } from "@lk-gtcom/ecomlab-components";
import { TitlePage } from '../../../TitlePage/TitlePage';
import { ModalComponent } from "../../ModalComponent/ModalComponent";
import './ModalAddPrompt.scss'

const ModalAddPrompt = ({
    createRule,
    prompt,
    setPrompt,
    setIsModal
}) => {

    return (
        <ModalComponent
            title='Добавить свой промт для ИИ'
            onClose={e => setIsModal(false)}
            style={{
                maxWidth: '500px',
                height: 'auto'
            }}
            child={
                <div className='modal-add-prompt'>

                    <TextareaDynamicPlaceholder
                        width='100%'
                        changeValue={prompt}
                        placeholder={'Введите текст'}
                        onChange={(e) => setPrompt(e)}
                    />

                    <div className='modal-add-prompt__group-btn'>
                        <ButtonBasic
                            grey
                            text='Отмена'
                            width='100%'
                            onClick={(e) => {
                                setIsModal(false)
                            }}
                        />

                        <ButtonBasic
                            green
                            text='Сохранить'
                            width='100%'
                            onClick={(e) => {
                                createRule()
                                setTimeout(() => setIsModal(false), 500)
                            }}
                        />
                    </div>
                </div>
            }
        />
    )
}

export { ModalAddPrompt }